import React from 'react';
import './TimeslotOverlay.scss';
import classNames from 'classnames';
import { EInputType, Input } from '@repo/apg-ui';

export interface Timeslot {
  title: string;
  value: string;
  className?: string;
  timeslot: number;
}

interface Props {
  options?: Timeslot[];
  selectedTimeslot: number[];
  onSelectionChange?: any;
  isDisabled?: boolean;
  allowedTimeslots?: number[];
}

export const TimeslotOverlay = ({
  options,
  onSelectionChange,
  selectedTimeslot,
  isDisabled,
  allowedTimeslots,
}: Props) => {
  if (isDisabled) return null;
  return (
    <div className='overlay-content timeslot'>
      <div className='d-flex flex-column align-items-start justify-content-start gap-3 w-100'>
        {options && options.length ? (
          <div className='d-flex flex-column align-items-start justify-content-start gap-3 w-100'>
            {options.map((option: Timeslot, index) => {
              const isAllowedTimeslot = allowedTimeslots.includes(option.timeslot);

              return (
                <div
                  key={`timeslot-option-${index}`}
                  className={classNames(
                    'd-flex align-items-center justify-content-start w-100 py-2',
                    options.length > 1 ? option.className : '',
                  )}
                >
                  <Input
                    inputType={EInputType.Checkbox}
                    type={'checkbox'}
                    name={`timeslot-option-${index}`}
                    checked={selectedTimeslot.includes(option.timeslot)}
                    disabled={!isAllowedTimeslot}
                    onChange={(name, value) => {
                      onSelectionChange(option.timeslot, value);
                    }}
                  />
                  <div
                    className={classNames('d-flex flex-column align-items-start justify-content-center', {
                      disabled: !isAllowedTimeslot,
                    })}
                  >
                    <span className='title'>{option.title}</span>
                    <span className='subtitle'>{option.value}</span>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
